/* =============================================================
   SHOPIFY PRODUCT JS — Final Corrected
   - outerHTML.includes() filter PRESERVED (your original working logic)
   - hide class + css display both used exactly like your old code
   - All scoped per container — no cross-contamination
   ============================================================= */

(function ($) {
  'use strict';

  /* ══════════════════════════════════════════════════════════════
     1. MODAL
  ══════════════════════════════════════════════════════════════ */

  $(document).on('click', '.Click-here', function () {
    $('.custom-model-main').addClass('model-open');
    $('body').addClass('hidden_mt');
  });

  $(document).on('click', '.close-btn, .bg-overlay', function () {
    $('.custom-model-main').removeClass('model-open');
    $('body').removeClass('hidden_mt');
  });


  /* ══════════════════════════════════════════════════════════════
     2. ADD-TO-CART — block if no variant selected
  ══════════════════════════════════════════════════════════════ */

  $(document).on('click', '.add-to-cart-button', function (event) {
    var $form     = $(this).closest('form');
    var $variants = $form.find('.custominputvariant');

    if ($variants.length > 0 && $variants.filter(':checked').length === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var optionName = $variants
        .first()
        .closest('.variant-input, .variant-wrapper')
        .find('.option_title')
        .first()
        .attr('custom-name') || 'Option';

      $form.find('#option-name-placeholder').text(optionName);
      $form.find('#metal-alert').show();
      return false;
    }
  });


  /* ══════════════════════════════════════════════════════════════
     3. INVENTORY MESSAGE — CORE FUNCTION
        YOUR EXACT ORIGINAL LOGIC:
        Step 1 → addClass('hide') + css display:none  ALL li
        Step 2 → removeClass('hide') + css display:block  correct ONE
        outerHTML.includes() filter so it finds data-* anywhere in li
        Scoped to closest form OR #quickshop only
  ══════════════════════════════════════════════════════════════ */

  function updateInventoryMessage($input) {
    var qty    = parseInt($input.attr('data-inventory-qty'), 10) || 0;
    var policy = ($input.attr('data-inventory-policy') || '').trim();

    var $container = $input.closest('form');
    if (!$container.length) $container = $input.closest('#quickshop');
    if (!$container.length) return;

    var $wrapper = $container.find('.custom_block_inventorymessage');
    if (!$wrapper.length) return;

    /* Step 1 — Hide ALL */
    $wrapper.find('.customsalesvariant')
      .addClass('hide')
      .css('display', 'none');
    $wrapper.find('.customstcoinput').prop('disabled', true);

    /* Step 2 — Show correct one */

    if (qty <= 0 && policy === 'continue') {
      /* BACK IN STOCK */
      $wrapper.find('.customsalesvariant').filter(function () {
        return this.outerHTML.includes('data-back-in-stock');
      })
      .removeClass('hide')
      .css('display', 'block')
      .find('.customstcoinput').prop('disabled', false);

    } else if (qty <= 0) {
      /* OUT OF STOCK */
      $wrapper.find('.customsalesvariant').filter(function () {
        return this.outerHTML.includes('data-out-of-stock');
      })
      .removeClass('hide')
      .css('display', 'block')
      .find('.customstcoinput').prop('disabled', false);

    } else if (qty >= 1) {
      /* IN STOCK */
      $wrapper.find('.customsalesvariant').filter(function () {
        return this.outerHTML.includes('data-in-stock');
      })
      .removeClass('hide')
      .css('display', 'block')
      .find('.customstcoinput').prop('disabled', false);
    }
  }


  /* ══════════════════════════════════════════════════════════════
     4. INVENTORY INIT ON LOAD

     CASE 1 — Has variants, NONE selected
              → hide ALL messages

     CASE 2 — Has variants, ONE already checked (URL param etc)
              → updateInventoryMessage for that checked input

     CASE 3 — NO variants at all
              → updateInventoryMessage with [data-inventory-qty]
                so correct message shows immediately on load
  ══════════════════════════════════════════════════════════════ */

  function handleInventoryOnLoad(context) {
    var $scope = context ? $(context) : $(document);
    var $variants = $scope.find('.custominputvariant');

    if ($variants.length > 0) {

      var $checked = $variants.filter(':checked');

      if ($checked.length) {
        /* CASE 2 — checked variant exists, show its message */
        updateInventoryMessage($checked);
      } else {
        /* CASE 1 — no variant selected yet, hide everything */
        $scope.find('.custom_block_inventorymessage .customsalesvariant')
          .addClass('hide')
          .css('display', 'none');
        $scope.find('.custom_block_inventorymessage .customstcoinput')
          .prop('disabled', true);
      }

    } else {
      /* CASE 3 — no variants on this product, show message directly */
      var $defaultInput = $scope.find('[data-inventory-qty]').first();
      if ($defaultInput.length) {
        updateInventoryMessage($defaultInput);
      }
    }
  }

  window.handleInventoryOnLoad = handleInventoryOnLoad;


  /* ══════════════════════════════════════════════════════════════
     5. THIRD-PARTY STOCK BLOCKS
        anie_heie / thomas_sabo / uno_new
        data-key true  → "In Stock"
        otherwise      → original Liquid text (stored on block el)
  ══════════════════════════════════════════════════════════════ */

  var STOCK_BLOCKS = [
    { cls: 'anie_heie_custom_class',   dataKey: 'acotisStock'       },
    { cls: 'thomas_sabo_custom_class', dataKey: 'thomasAcotisStock' },
    { cls: 'uno_new_custom_class',     dataKey: 'unoAcotisStock'    }
  ];

  function updateStockFromSelected(container) {
    if (!container) return;

    var selected = container.querySelector(
      '.custominputvariant:checked, .variant-input input:checked'
    );
    if (!selected) return;

    STOCK_BLOCKS.forEach(function (cfg) {
      var block = container.querySelector('.' + cfg.cls);
      if (!block) return;

      var textEl      = block.querySelector('.js-incoming-text');
      var hiddenInput = block.querySelector('.customstcoinput');
      if (!textEl || !hiddenInput) return;

      if (!block.dataset.originalText) {
        block.dataset.originalText = textEl.textContent.trim();
      }

      var isInStock = selected.dataset[cfg.dataKey] === 'true';
      var text      = isInStock ? 'In Stock' : block.dataset.originalText;

      textEl.textContent = text;
      hiddenInput.value  = text;
    });
  }


  /* ══════════════════════════════════════════════════════════════
     6. CHRISTMAS / NOT-GUARANTEED DELIVERY PROPERTY
  ══════════════════════════════════════════════════════════════ */

  function updateChristmasProperty(inputEl) {
    var qty      = parseInt($(inputEl).attr('data-inventory-qty'), 10) || 0;
    var $form    = $(inputEl).closest('form');
    var $wrapper = $form.find('.not-guaranteed-wrapper');

    $form.find('input[name="properties[Christmas]"]').remove();

    if (qty <= 0) {
      $wrapper.show();
      $('<input>', {
        type:  'hidden',
        name:  'properties[Christmas]',
        value: $wrapper.find('span').text()
      }).appendTo($form);
    } else {
      $wrapper.hide();
    }
  }


  /* ══════════════════════════════════════════════════════════════
     7. RING SIZE MIRROR
  ══════════════════════════════════════════════════════════════ */

  var $preRing = $('input[name="properties[Ring Size]"]:checked');
  if ($preRing.length) {
    $('.Ring-size-mt').val($preRing.val());
  }

  $(document).on('change', '.variant-input_mt input', function () {
    $('.Ring-size-mt').val($(this).val());
  });


  /* ══════════════════════════════════════════════════════════════
     8. ADD-TO-CART BUTTON TEXT UPDATE
  ══════════════════════════════════════════════════════════════ */

  $(document).on('change', '.variant-input input', function () {
    var $el = $('span[data-add-to-cart-text]');
    if ($el.length) {
      $('.customaddtocart').text($el.text().trim());
    }
  });


  /* ══════════════════════════════════════════════════════════════
     9. MASTER VARIANT CHANGE HANDLER
        One delegated listener — all sub-functions scoped
        to the container the changed input lives in
  ══════════════════════════════════════════════════════════════ */

  $(document).on('change', '.custominputvariant, .variant-input input', function () {
    var $input = $(this);

    var $container = $input.closest('form');
    if (!$container.length) $container = $input.closest('#quickshop');

    /* 9a — Hide metal/option alert */
    var $purchaseBlock = $input.closest('.shopify-product-form');
    if ($purchaseBlock.length) {
      $purchaseBlock.find('#metal-alert').hide();
    }

    /* 9b — Auto-select first swatch in empty groups (same container only) */
    if ($container.length) {
      $container.find('.variant-input.swatch').each(function () {
        var $group = $(this);
        if ($group.find('.custominputvariant:checked').length === 0) {
          $group.find('.custominputvariant')
            .first()
            .prop('checked', true)
            .trigger('change');
        }
      });
    }

    /* 9c — Inventory message li hide/show */
    updateInventoryMessage($input);

    /* 9d — Third-party stock blocks */
    if ($container.length) {
      updateStockFromSelected($container[0]);
    }

    /* 9e — Christmas property */
    updateChristmasProperty(this);
  });


  /* ══════════════════════════════════════════════════════════════
     10. PAGE LOAD INIT
  ══════════════════════════════════════════════════════════════ */

  $(document).ready(function () {

    /* Init each product form */
    $('form[action="/cart/add"]').each(function () {
      handleInventoryOnLoad(this);
      updateStockFromSelected(this);
    });

    /* Christmas for pre-checked */
    var $preChecked = $('.variant-input input:checked');
    if ($preChecked.length) {
      updateChristmasProperty($preChecked[0]);
    }

    /* URL ?variant= pre-selection */
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    var optionLen = $('select.product-single__variants option').attr('data-length');

    if (optionLen !== '1') {
      if (variantId) {
        $('#add-to-cart-button').removeClass('disabled-add-to-cart');
      } else {
        $('.variant-input input').removeAttr('checked');
        $('#add-to-cart-button').addClass('disabled-add-to-cart');
        $('select.product-single__variants').attr('selected', 'selected');
      }
    }

    /* If custominputvariant already checked on load → show its block */
    if ($('input.custominputvariant:checked').length) {
      $('.customsalesvariant').css('display', 'block');
    }

    /* Per-form MutationObserver — same 3-case logic */
    $('form[action="/cart/add"]').each(function () {
      var formEl = this;

      var formObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'childList' || m.type === 'attributes') {

            var $allVariants = $(formEl).find('.custominputvariant');
            var $checked     = $allVariants.filter(':checked');

            if ($allVariants.length === 0) {
              /* No variants — show correct message from default input */
              var $def = $(formEl).find('[data-inventory-qty]').first();
              if ($def.length) updateInventoryMessage($def);

            } else if ($checked.length) {
              /* Variant selected — show its message */
              updateInventoryMessage($checked);

            } else {
              /* Variants exist, none selected — hide all */
              $(formEl).find('.custom_block_inventorymessage .customsalesvariant')
                .addClass('hide')
                .css('display', 'none');
              $(formEl).find('.custom_block_inventorymessage .customstcoinput')
                .prop('disabled', true);
            }

          }
        });
      });

      formObserver.observe(formEl, {
        childList:       true,
        subtree:         true,
        attributes:      true,
        attributeFilter: ['checked']
      });
    });

  });


  /* ══════════════════════════════════════════════════════════════
     11. QUICK VIEW — fully isolated
  ══════════════════════════════════════════════════════════════ */

  (function () {
    var activeProductURL = null;
    var isProcessing     = false;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-quick-shop-link');
      if (!btn) return;
      activeProductURL = btn.dataset.url;
      isProcessing     = false;
    });

    var quickshop = document.getElementById('quickshop');
    if (!quickshop) return;

    var qsObserver = new MutationObserver(function () {
      if (!activeProductURL || isProcessing) return;

      var detailsContainer = quickshop.querySelector(
        '.product__details--product-page'
      );
      if (!detailsContainer) return;

      isProcessing = true;

      fetch(activeProductURL)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');

          var freshBlock = doc.querySelector(
            '.purchase-details.custom_purchase-details'
          );
          if (!freshBlock) return;

          freshBlock = freshBlock.cloneNode(true);

          var existingBlock = detailsContainer.querySelector(
            '.purchase-details.custom_purchase-details'
          );
          if (existingBlock) {
            existingBlock.replaceWith(freshBlock);
          } else {
            detailsContainer.appendChild(freshBlock);
          }

          /* Init scoped to #quickshop ONLY */
          handleInventoryOnLoad(quickshop);
          updateStockFromSelected(quickshop);

          setTimeout(function () {
            var selected = quickshop.querySelector(
              '.custominputvariant:checked, .variant-input input:checked'
            );
            if (selected) {
              $(selected).trigger('change');
            }
          }, 50);
        })
        .catch(console.error)
        .finally(function () {
          activeProductURL = null;
          isProcessing     = false;
        });
    });

    qsObserver.observe(quickshop, { childList: true, subtree: true });

    quickshop.addEventListener('change', function (e) {
      if (
        e.target.matches('.custominputvariant') ||
        e.target.closest('.variant-input')
      ) {
        setTimeout(function () {
          updateStockFromSelected(quickshop);
        }, 50);
      }
    });

  })();

}(jQuery));




  // product grid stock message start

(function () {

  function loadGridMessages(card) {

    var productUrl = card.dataset.productUrl;
    if (!productUrl) return;

    fetch(productUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var purchaseBlock = card.querySelector('.product_grid_purchase');
        if (!purchaseBlock) return;

        function insertMessages() {

          var inventoryMsg = doc.querySelector('.purchase-details .custom_block_inventorymessage');
          if (inventoryMsg && !card.querySelector('.custom_block_inventorymessage')) {
            purchaseBlock.insertAdjacentElement('beforebegin', inventoryMsg.cloneNode(true));
          }

          var notGuaranteed = doc.querySelector('.purchase-details .not-guaranteed-wrapper');
          if (notGuaranteed && !card.querySelector('.not-guaranteed-wrapper')) {
            purchaseBlock.insertAdjacentElement('beforebegin', notGuaranteed.cloneNode(true));
          }
        }

        // try immediately
        insertMessages();

        // retry few times in case content loads later
        var tries = 0;
        var interval = setInterval(function () {
          insertMessages();
          tries++;
          if (tries > 5) clearInterval(interval);
        }, 500);

      })
      .catch(console.error);
  }

  function initGridMessages() {
    document.querySelectorAll('.product_grid_card[data-product-url]').forEach(function(card){
      loadGridMessages(card);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGridMessages);
  } else {
    initGridMessages();
  }

})();

  // product grid stock message end
